<template>



	<div class="form_page valign">
		<div class="w-100">

			<form v-on:submit.prevent="login">

				<router-link to="/">
					<img src="../assets/logo.png" class="logo">
				</router-link>

				<div class="form-group">
					<label>Usuario:</label>
					<input type="text" v-model="form.username" class="form-control">
				</div>

				<div class="form-group">
					<label>Contraseña:</label>
					<input type="password" v-model="form.password" class="form-control">
				</div>

				<div class="form-group">
					<label>Token:</label>
					<input type="text" v-model="form.token" class="form-control">
				</div>

				<button type="submit" class="mt-3 btn btn-space btn-primary w-100">Iniciar sesión</button>

				<div class="mt-3">
					<router-link :to="{name: 'forgot'}">¿Olvidaste tu contraseña?</router-link>
					
				</div>

			</form>

		</div>

	</div>
</template>



<script>
import { LOGIN } from "@/store/actions.type";

export default {
  data: function() {
    return {
      form: { username: "", password: "", token: "" }
    };
  },

  methods: {
    login: function() {
      this.$store
        .dispatch(LOGIN, this.form)
        .then(user => {
          var need2fa = user.needToken && !this.form.token;
          if (need2fa) {
            this.$router.push({ name: "2fa" });
          } else {
            this.$router.push({ name: "dashboard" });
          }
        })
        .catch(error => this._handleError(error));
    },

    _handleError: function(error) {
      this.form.password = "";
      this.$snotify.error(error.message);
    }
  }
};
</script>

<style lang="scss">
</style>
